import { ThemeProvider } from 'styled-components';
import type { IAdvisorToolbox } from './shared/types';
import ToolboxInline from './toolboxInline';
import ToolboxQuickView from './toolboxQuickView';

const AdvisorToolbox = (props: IAdvisorToolbox) => {
    const { inline } = props;

    return (
        <ThemeProvider theme={{ ToolboxTheme: { inline } } as any}>
            {inline ? <ToolboxInline {...props} /> : <ToolboxQuickView {...props} />}
        </ThemeProvider>
    );
};

export default AdvisorToolbox;
